<template>
  <div
    id="question-list"
    class="block lg:flex">
    <div
      v-for="(examination, key, index) in examArray"
      :key="index">
      <div class="text-center w-full max-w-rxl px-4 lg:px-4">
        <div
          class="inline-block overflow-hidden bg-white shadow-xl px-4 my-7 border-solid border border-gray-200">
          <div class="font-bold text-lg mt-6 mx-2">{{ key }}</div>
          <div class="flex items-center my-4 ml-3">
            <div
              class="rounded-full bg-red-100"
              style="width: 30px; height: 20px"></div>
            <div class="mr-5">：正答</div>
            <div
              class="rounded-full bg-green-100"
              style="width: 30px; height: 20px"></div>
            <div>：解答</div>
          </div>
          <ul
            class="grid grid-flow-col question-list"
            :class="{'question-list-general': index === 1}">
            <div
              v-for="(question, index) in examination"
              :key="question.id">
              <li
                class="text-base whitespace-nowrap mb-1 mx-2 py-1 cursor-pointer box-border bg-white rounded-md border-2"
                style="width: 200px">
                <span class="grid grid-cols-5 content-center">
                  <p class="col-span-2 text-right">
                    {{ `${index + 1}問目：` }}
                  </p>
                  <p
                    class="col-span-1 text-center rounded-full bg-red-100 mr-1">
                    {{ `${correctAnswer(question.choices_order)}` }}
                  </p>
                  <p class="col-span-1 text-center rounded-full bg-green-100">
                    {{
                      `${answer(question.question_id, question.choices_order)}`
                    }}
                  </p>
                  <div
                    v-if="
                      isCorrect(question.question_id, question.choices_order)
                    "
                    class="flex justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="col-span-1 h-6 w-6 inline text-red-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div
                    v-else
                    class="flex justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="col-span-1 inline h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="rgb(29, 78, 216)">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </div>
                </span>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { storeToRefs } from 'pinia'
import defineStore from '../../../stores/user-answer-status'
import DataTable from '@/Common/DataTable'

const props = defineProps({
  currentQuestion: {
    type: Array,
    default: () => [],
  },
  compulsoryQuestion: {
    type: Array,
    default: () => [],
  },
  generalQuestion: {
    type: Array,
    default: () => [],
  },
  practiceQuestion: {
    type: Array,
    default: () => [],
  },
})

const examArray = {
  必須: props.compulsoryQuestion,
  一般: props.generalQuestion,
  実地: props.practiceQuestion,
}

const isCorrect = (id, choicesOrder) => {
  const answerObject = props.currentQuestion.find(
    (questionAnswer) => questionAnswer.question_id === id,
  )
  if (answerObject) {
    let correctAnswer = 0
    const answerIndex = choicesOrder.indexOf(answerObject.answer_type)
    choicesOrder.find((value, index) => {
      if (value === 1) {
        correctAnswer = index + 1
      }
    })
    return answerIndex + 1 === correctAnswer
  }
  return false
}

const correctAnswer = (choicesOrder) => {
  let correctAnswer = 0
  choicesOrder.find((value, index) => {
    if (value === 1) {
      correctAnswer = index + 1
      return true
    }
  })
  return correctAnswer
}

const answer = (id, choicesOrder) => {
  const answerObject = props.currentQuestion.find(
    (questionAnswer) => questionAnswer.question_id === id,
  )

  if (answerObject) {
    const answerIndex = choicesOrder.indexOf(answerObject.answer_type)
    return answerIndex + 1
  }
  return '-'
}
</script>

<style scoped>
.question-list {
   grid-template-rows: repeat(25, 1fr);
}

@media screen and (max-width: 1900px) {
   .question-list {
      grid-template-rows: repeat(50, 1fr);
   }
}

@media screen and (max-width: 1024px) {
   .question-list {
      grid-template-rows: repeat(25, 1fr);
   }

   .question-list-general {
      grid-template-rows: repeat(50, 1fr);
   }
}

@media screen and (max-width: 480px) {
   .question-list {
      grid-template-rows: repeat(50, 1fr);
   }

   .question-list-general {
      grid-template-rows: repeat(100, 1fr);
   }
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 50, 0.5);
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3);
}
</style>
